module.exports = __webpack_public_path__ + "static/media/fuel-level-total-fuel-used.33ae79b9.svg";